// OneTrust consent cookie
export const ONETRUST_CONSENT_COOKIE = 'OptanonConsent';
export const ONETRUST_COOKIE_CATEGORIZATION_ATTRIBUTE = 'groups';

export const ONETRUST_COOKIE_CATEGORIZATIONS = {
  C0001: 'StrictlyNecessary',
  C0002: 'Performance',
  C0003: 'Functional',
  C0004: 'AcceptAll',
};

/**
 * Decode the cookie data and extract the attribute details.
 * @param {string} attribute - The attribute to search in the cookie data.
 * @param {string[]} cookieData - The cookie data as an array.
 * @returns {string | null}
 */
export function decodeCookieData(attribute, cookieData) {
  for (const element of cookieData) {
    const data = element.trim();
    const key = data.split('=')[0];
    if (key === attribute) {
      return data.substring(key.length + 1);
    }
  }
  return null;
}

/**
 * Extract the cookie categorizations
 * @param {string} categories - the cookie categories related to Strictly Necessary, Performance, Functional.
 * @returns {object | undefined}
 * @example
 * // Basic usage:
 * extractCookieCategorizations('C0001:1,C0003:1,C0002:1,C0004:1');
 */
export function extractCookieCategorizations(categories) {
  const cookieCategories = categories ? categories.split(',') : [];
  if (cookieCategories.length) {
    const cookieSpecifications = {};
    for (const categoryDetails of cookieCategories) {
      const [categoryKey, categoryValue] = categoryDetails.split(':');
      const cookieName = ONETRUST_COOKIE_CATEGORIZATIONS[categoryKey];
      if (cookieName) {
        cookieSpecifications[cookieName] = categoryValue === '1';
      }
    }
    return cookieSpecifications;
  }
  return undefined;
}

/**
 * Get the OneTrust cookie categories
 * @returns {object | undefined}
 */
export function getOneTrustCookies() {
  const cookies = document.cookie.split(';');
  const oneTrustCookie = decodeCookieData(ONETRUST_CONSENT_COOKIE, cookies);
  if (oneTrustCookie) {
    const decodedCookie = decodeURIComponent(oneTrustCookie);
    const cookieGroup = decodeCookieData(ONETRUST_COOKIE_CATEGORIZATION_ATTRIBUTE, decodedCookie.split('&'));
    const userSelectedPreferences = extractCookieCategorizations(cookieGroup);
    // eslint-disable-next-line no-console
    console.log('OneTrust: User selected preferences', userSelectedPreferences);
    return userSelectedPreferences;
  }
  // eslint-disable-next-line no-console
  console.warn('OneTrust: No Cookie detected.');

  return undefined;
}
